import { render, staticRenderFns } from "./suspend.vue?vue&type=template&id=26033024&scoped=true"
import script from "./suspend.vue?vue&type=script&lang=js"
export * from "./suspend.vue?vue&type=script&lang=js"
import style0 from "./suspend.vue?vue&type=style&index=0&id=26033024&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26033024",
  null
  
)

export default component.exports